import { AxiosInstance } from 'axios';

import * as common from '../../../../../../typings/api/skymap/rest/v0/.common';
import * as types from '../../../../../../typings/api/skymap/rest/v0/shared-view';

export class SharedViewService implements types.Handlers {
  constructor(private axios: AxiosInstance) {}
  createSharedView(
    params: types.CreateSharedViewParameters,
  ): Promise<types.CreateSharedViewResponse> {
    throw new Error('Method not implemented.');
  }
  fetchById(params: types.FetchByIdParameters): Promise<common.FetchSharedViewResponse> {
    throw new Error('Method not implemented.');
  }
  deleteSharedView(params: types.DeleteSharedViewParameters): Promise<void> {
    throw new Error('Method not implemented.');
  }
  getAssets(params: types.GetAssetsParameters): Promise<types.GetAssetsResponse> {
    throw new Error('Method not implemented.');
  }
  getModels(params: types.GetModelsParameters): Promise<types.GetModelsResponse> {
    throw new Error('Method not implemented.');
  }
  getProjectInfo(params: types.GetProjectInfoParameters): Promise<common.FindProjectResponse> {
    throw new Error('Method not implemented.');
  }

  async getTiledModel({
    path,
  }: types.GetTiledModelParameters): Promise<common.GetTiledModelResponse> {
    return (await this.axios.get(`/shared-views/${path.id}/tiled-models/${path.tiledModelId}`))
      .data;
  }

  async getPointCloud({
    path,
  }: types.GetPointCloudParameters): Promise<common.FetchPointCloudResponse> {
    return (
      await this.axios.get(`/shared-views/${path.id}/scans/${path.pointCloudId}/signed-request`)
    ).data;
  }

  /**
   *  Fetch the signed CloudFront url for scans in shared view.
   * @param root0
   * @param root0.path
   */
  async getScanSignedRequest({
    path,
  }: types.GetScanSignedRequestParameters): Promise<common.SignedRequestResponse> {
    return (await this.axios.get(`/shared-views/${path.id}/scans/${path.scanId}/signed-request`))
      .data;
  }

  async getTiledModelSignedRequest({
    path,
  }: types.GetTiledModelSignedRequestParameters): Promise<common.SignedRequestResponse> {
    return (
      await this.axios.get(
        `/shared-views/${path.sharedViewId}/tiled-models/${path.tiledModelId}/signed-request`,
      )
    ).data;
  }

  /**
   *  Fetch the signed CloudFront url for point clouds in shared view.
   * @param root0
   * @param root0.path
   * @param root0.query
   */
  async getPointCloudSignedRequest({
    path,
    query,
  }: types.GetPointCloudSignedRequestParameters): Promise<common.SignedRequestResponse> {
    return (
      await this.axios.get(
        `/shared-views/${path.id}/pointcloud/${path.pointCloudId}/signed-request`,
        {
          params: query,
        },
      )
    ).data;
  }

  /**
   *  Fetch the signed CloudFront url for ortho tiles in shared view.
   * @param root0
   * @param root0.path
   * @param root0.path.id
   * @param root0.path.orthoTileId
   */
  async getOrthoTileSignedRequest({
    path: { id, orthoTileId },
  }: types.GetOrthoTileSignedRequestParameters): Promise<common.SignedRequestResponse> {
    return (await this.axios.get(`/shared-views/${id}/ortho-tiles/${orthoTileId}/signed-request`))
      .data;
  }

  async fetchVolumeModelUrls(
    params: types.FetchVolumeModelUrlsParameters,
  ): Promise<common.DownloadUrlArrayResponse> {
    return (
      await this.axios.get(
        `/shared-views/${params.path.id}/volume/${params.path.volumeId}/model-urls`,
      )
    ).data;
  }

  async getCadFilesV1({
    path: { id },
  }: types.GetCadFilesV1Parameters): Promise<types.GetCadFilesResponse> {
    return (await this.axios.get(`/shared-views/${id}/cad-files-v1`)).data;
  }

  async getDxfSignedUrlV1(
    params: types.GetDxfSignedUrlV1Parameters,
  ): Promise<common.DownloadDxfURLResponse> {
    return (
      await this.axios.get(
        `/shared-views/${params.path.id}/dxf-v1/${params.path.fileId}/signed-url`,
        { params: params.query },
      )
    ).data;
  }
}
